// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"39":"7d404ffb","184":"f795af35","795":"e934b087"}[chunkId] + ".js";
};